<template>
  <div class="add-mentee-form">   
    <div class="add-form-wrapper">
      <h3 class="add-form-heading" v-show="form_type == 'add_mentor'">Add Mentor</h3>
      <h3 class="add-form-heading" v-show="form_type == 'add_manager'">Add Manager</h3>
    </div>

    <div class="content-main-wrapper center">

        <div class="row" v-show="successMessage != ''">
          <div class="col-12 p-0">
            <div class="alert alert-success" role="alert">
              {{ successMessage }}
            </div>
          </div>
        </div>

        <form @submit.prevent="onSubmit">
		      <div class="row">
            <div class="col-12 p-0">
      			  <input
      					type="first_name"
      					name="first_name"
      					id="first_name"
      					class="col-12 col-sm-12 input-height-35 form-control"
      					ref="first_name"
      					v-validate="{ rules: { required: true, regex: nameRegex() } }"
      					v-model="first_name"
                data-vv-as="First name"
                placeholder="First Name"
                maxlength="180">
      			  <div v-if="verrors.firstByRule('first_name', 'required')" class="validate-warning-msg">The First Name is required</div>
              <div v-if="verrors.firstByRule('first_name', 'regex')" class="validate-warning-msg">The First Name should only contain - and _</div>
            </div>
         
             <div class="col-12 p-0" style="margin-top: 10px;">     
              <input
                type="last_name"
                name="last_name"
                id="last_name"
                class="col-12 col-sm-12 input-height-35 form-control"
                ref="last_name"
                v-validate="{ rules: { required: true, regex: nameRegex() } }"
                v-model="last_name"
                data-vv-as="Last name"
                placeholder="Last Name"
                maxlength="180">
              <div v-if="verrors.firstByRule('last_name', 'required')" class="validate-warning-msg">The Last Name is required</div>
              <div v-if="verrors.firstByRule('last_name', 'regex')" class="validate-warning-msg">The Last Name should only contain - and _</div>
            </div>
         
            <div class="col-12 p-0" style="margin-top: 10px;">
              <input
                  type="email_addr"
                  name="email"
                  id="email_addr"
                  class="col-12 col-sm-12 input-height-35 form-control"
                  ref="email_addr"
                  v-validate="'required|email'"
                  v-model="email_addr"
                  data-vv-as="Email Address"
                  placeholder="Email Address"
                  maxlength="180">
              <div v-show="verrors.has('email')" class="validate-warning-msg">{{ verrors.first('email') }}</div>
            </div>

            <div class="col-12 p-0" style="margin-top: 10px;">         
              <input
                  type="phone_number"
                  name="phone_number"
                  id="phone_number"
                  class="col-12 col-sm-12 input-height-35 form-control"
                  ref="phone_number"
                  @keyup="adminPhoneValid($event)"
                  @blur="adminPhoneValid($event)"
                  v-validate="{ rules: { regex: adminPhoneRegex() } }"
                  v-model="phone_number"
                  data-vv-as="Phone number"
                  placeholder="Phone Number"
                  maxlength="14">
              <div v-if="verrors.has('phone_number')" class="validate-warning-msg">The Phone Number is invalid</div>
            </div>

            <div class="col-12 p-0 mt-3" v-if="form_type == 'add_mentor'">
              <label
                  for="mentor"
                  class="col-12 bold"> Assign Mentees</label>
                  
                <div class="ml-3" v-if="menteesApprentices.length == 0">No mentees added, yet!</div>

                <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in menteesApprentices">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" :value="option.id" :id="form_type + '_mentee_' + option.id" v-model="assign_mentees">
                    <label class="custom-control-label" :for="form_type + '_mentee_' + option.id">{{ option.first_name + ' ' + option.last_name }}</label>
                  </div>
                </div>
            </div>

            <div class="col-12 p-0" v-if="form_type == 'add_mentor'">

              <div class="col-12 p-0 mt-3" v-if="taskList.length > 0">
                <label
                    for="roles"
                    class="col-12 bold">Assign Tasks </label>

                <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in taskList">

                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" :value="option.id" :id="form_type + '_assessment_chkbox_' + option.id" name="Tasks" v-model="taskListSelected"  v-validate="'required'">
                    <label class="custom-control-label" :for="form_type + '_assessment_chkbox_' + option.id">{{ option.name }}</label>
                  </div>

                </div>


                <div v-show="verrors.has('Tasks')" class="validate-warning-msg">You have to assign Tasks</div>
              </div>




           <div class="col-12 p-0" style="margin-top: 10px;">
                <label
                    for="roles"
                    class="col-12 bold">Assign Pathway: </label>
                <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(pathway, key, index) in pathwayList">
                  <div class="chkboxwrapper">
                    <div class="custom-control custom-radio">
                      <input 
                        name="pathway_assigned"
                        :value="pathway.id"                       
                        type="radio" 
                        v-model="pathwaySelected"
                        @change="getPathwaySteps"
                        v-validate="'required'"
                        class="custom-control-input"
                        :id="'add_mentor_pathway_' + pathway.id"
                        >
                      <label class="custom-control-label" :for="'add_mentor_pathway_' + pathway.id">{{ pathway.pathwayName }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-12 pl-0" v-if="pathwayList.length == 0" style="color: #707070;">
                  No Pathways for this account.
                </div>
                <div v-if="verrors.has('pathway_assigned')" class="margin-bottom-5 validate-warning-msg">Pathway is required</div>
           </div>


              <div class="col-12 p-0"  v-if="pathwayList.length > 0 && pathwaySelected > 0"" style="margin-top: 10px;">
               <div class="row">
                <div class="col-8 d-inline"> 
                  <label
                      for="roles"
                      class="col-12 bold">Begin at step: </label>
                </div>     
                <div class="col-4">
                  <div class="chkboxwrapper">
                    <div class="custom-control custom-checkbox">
                      <input 
                        name="future steps"
                        value="1"                                           
                        type="checkbox" 
                        v-model="showFutureSteps"                      
                        class="custom-control-input"
                        :id="'add_mentor_future_steps'" 
                        >
                      <label class="custom-control-label" :for="'add_mentor_future_steps'">Show future steps</label>
                    </div>
                  </div>
                </div>
               </div> 
                <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(step, key, index) in pathwaySteps">
                  <div class="chkboxwrapper">
                    <div class="custom-control custom-radio">
                      <input 
                        name="Begin at step"
                        :value="step.id"                       
                        type="radio" 
                        v-model="stepSelected"                      
                        class="custom-control-input"
                        :id="'add_mentor_step_' + step.id"
                        >
                      <label class="custom-control-label" :for="'add_mentor_step_' + step.id">{{ step.stepTitle }}</label>
                    </div>
                  </div>
                </div>
              </div>


            <div class="col-12 p-0" style="margin-top: 7px;" v-if="pathwaySelected > 0">
              <label
                  for="mentor"
                  class="col-12 bold"> Assign Mentors: <span class="required">*</span></label>
                  <div class="col-12 col-sm-12 tasklist-assign-wrapper"  v-for="(option, key, index) in groups">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        <input 
                        name="mentor_assigned"
                        :value="option.id" 
                        :id="'add_mentee_mentor_' + option.id" 
                        type="checkbox" 
                        v-model="mentor_assigned"
                        v-validate="'required'"
                        class="custom-control-input"
                        > 
                        <label class="custom-control-label" :for="'add_mentee_mentor_' + option.id">{{ option.groupName }}</label> 
                      </div>
                    </div>
                  </div>
                  <div v-if="verrors.has('mentor_assigned')" class="margin-bottom-5 validate-warning-msg">Mentor is required</div>

            </div>



            </div>

            <div class="col-12 p-0" v-if="form_type == 'add_manager'">

            <div class="col-12 p-0 mt-3" v-if="assessments.length > 0">
              <label
                  for="roles"
                  class="col-12 bold">Assign Assessments </label>
              <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in assessments">

                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" :value="option.id" :id="form_type + '_assessment_chkbox_' + option.id" name="Assessment" v-model="assessmentSelected"  v-validate="'required'">
                  <label class="custom-control-label" :for="form_type + '_assessment_chkbox_' + option.id">{{ option.name }}</label>
                </div>

              </div>
              <div v-show="verrors.has('Assessment')" class="validate-warning-msg">You have to assign Assessments</div>
            </div>

            <div class="col-12 p-0 mt-3" v-if="courses.length > 0"  style="margin-top: 10px;">
              <label
                  for="courses"
                  class="col-12 bold">Assign Courses</label>
              <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(option, key, index) in courses">
               
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" :value="option.id" :id="form_type + 'course_chkbox_' + option.id" v-model="courseSelected"  v-validate="'required'" name="Course">
                  <label class="custom-control-label" :for="form_type + 'course_chkbox_' + option.id">{{ option.name }}</label>
                </div>

              </div>
              <div v-show="verrors.has('Course')" class="validate-warning-msg">You have to assign Courses</div>
            </div>

          </div>

          </div>



          <div class="submit margin-bottom-15 mt-3" style="text-align: center;">
            <button :disabled="disable_add_btn" type="submit" class="btn btn-info ma-blue-btn" @click="buttonAction = 'save'" v-show="form_type == 'add_mentor'">Add Mentor</button>
            <button :disabled="disable_add_btn" type="submit" class="btn btn-info ma-blue-btn" @click="buttonAction = 'save'" v-show="form_type == 'add_manager'">Add Manager</button>
            <div class="mt-2 mb-5">
              <button :disabled="disable_add_btn" type="submit" class="btn btn-link save_add_link branding_text_color" @click="buttonAction = 'save_and_add'">Save & Add Another</button>
            </div>
          </div>
        </form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import { store } from '../../store/store';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: ['form_type'],
  data: function () {
    return {
      first_name: '',
      last_name: '',
      phone_number: '',
      email_addr: '',
	    password: '',
      pw_confirm: '',
      accountId: '',
      formType: (this.$route.path == '/add-manager') ? 'Manager' : 'Mentor',
      assessments: [],
      assessmentSelected: [],
      courses: [],
      courseSelected: [],
      buttonAction: 'save',
      successMessage: '',
      menteeCount: '',
      menteesApprentices: [],
      assign_mentees: [],
      disable_add_btn: false,
      pathwayList: [],
      pathwaySteps: [],
      pathwaySelected: 0,
      stepSelected: '',
      showFutureSteps: 1,
      defaultstep: '',
      taskList: [],
      taskListSelected: [],
      mentor_assigned: [],
      groups: [],
    };
  },
  computed: {
    getFormTitle() {
      return (this.$route.path == '/add-manager') ? 'Manager' : 'Mentor';
    }
  },
  methods: {
    nameRegex: function() {
      return /^[a-zA-Z-_ ']*$/;
    },
    getPathwaySteps() {
      this.pathwaySteps = [];
      this.defaultstep = '';
      this.stepSelected = '';
      axios('/get-pathway-steps-name',
          {
            method: 'GET',
            params: {
              pathway_id: this.pathwaySelected,
            }
          },
        )
        .then(response => {
              this.defaultstep = response.data[0].id;            
              this.pathwaySteps = response.data;
        })
        .catch(error => {

        });
    },
    getPathwayLists() {
      this.pathwayList = [];
      axios('/get-pathway-add-mentee',
            {
              method: 'GET',
              params: {
                account_id: this.$store.state.user_accountid,
              }
            },
          )
          .then(response => {
              var list =  { id: 0, pathwayName: 'No Pathway' };
              this.pathwayList.push(list);
              for(var i=0; i <= response.data.length; i++) {
                var list = {id: response.data[i].id, pathwayName: response.data[i].pathwayName};
                this.pathwayList.push(list);
              }
              
          })
          .catch(error => {

          });
    },       
    adminPhoneRegex: function() {
      return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    },
    adminPhoneValid: function(event) {
      var phone_val = this.phone_number;
      this.phone_number = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    },
    doFormReset() {
      this.first_name = '';
      this.last_name = '';
      this.phone_number = '';
      this.email_addr = '';
      this.assessmentSelected = [];
      this.courseSelected = [];
      this.assign_mentees = [];
      this.pathwaySelected = 0;
      this.stepSelected = '';
      this.defaultstep = '';
      this.taskListSelected = [];
      //this.taskList = [];
      //this.pathwayList = [];
      this.pathwaySteps = [];
      this.mentor_assigned = [];
      this.$validator.reset();
    },
    onSubmit () {
        this.$validator.validateAll().then((result) => {
          if(!result) {
            return;
          }
          
          this.createMentor();
        })
        .catch(() => {

        });
    },
    createMentor() {
        //make axios call to the API
        // if (this.formType == 'Manager') {
        if(this.form_type == 'add_manager') {
          this.disable_add_btn = true;
          axios('/users',
            {
              method: 'POST',
              data: {
                "username": this.email_addr,
                "email": this.email_addr,
                "roles": ["ROLE_ADMIN", "ROLE_MENTOR"],
                "first_name": this.first_name,
                "last_name": this.last_name,
                "phone_number": this.phone_number,
                "enabled": true,
                "signin_count": 0,
                "account_id": this.$store.state.user_accountid,
                "assessments_assigned": this.assessmentSelected,
                "course_assigned": this.courseSelected,
              }
            },
          )
          .then(response => {
              // this.flash({ message: 'New Manager Added Successfully!', variant: 'success' });
              // this.navigate('/company-admin-dashboard');

              this.disable_add_btn = false;
              this.successMessage = 'New Manager Added Successfully!';
              this.doFormReset();

              if (this.buttonAction == 'save') {
                this.$refs.first_name.focus();
                setTimeout(() => {
                  this.successMessage = '';
                  this.$emit('closeMentorModal');
                  window.location.reload(); 
                }, 2000);              
              } else {
                this.$refs.first_name.focus();
                setTimeout(() => {
                  this.successMessage = '';                
                }, 2000);              
              }
          })
          .catch(error => {
            this.disable_add_btn = false;
              const fieldErrors =  [{}];
              // Parse JSON string
              var errMsgObj = JSON.parse(error.response.data.message);
              Object.keys(errMsgObj).map(key => {
                var newFieldErr = {field:key, msg:errMsgObj[key]};
                fieldErrors.push(newFieldErr);
              });
              this.$validator.errors.add(fieldErrors);
          });
        } else {
          //this.disable_add_btn = true;
          this.assessmentSelected = [];
          this.courseSelected = [];
          for(var k=0; k < this.taskListSelected.length; k++) {
            var idd = this.taskListSelected[k];
            var myArray = idd.split("-");
            if(myArray[1] == 'Assessment') {
              this.assessmentSelected.push(myArray[0]);
            }
            if(myArray[1] == 'Course') {
              this.courseSelected.push(myArray[0]);
            }
          }
          setTimeout(() => {
          axios('/users',
            {
              method: 'POST',
              data: {
                "username": this.email_addr,
                "email": this.email_addr,
                "roles": ["ROLE_MENTOR"],
                "first_name": this.first_name,
                "last_name": this.last_name,
                "phone_number": this.phone_number,
                "enabled": true,
                "signin_count": 0,
                "account_id": this.accountId,
                "assessments_assigned": this.assessmentSelected,
                "course_assigned": this.courseSelected,
                "assign_mentees": this.assign_mentees,
                "pathway_assigned": this.pathwaySelected,
                "begin_step": this.stepSelected == ''? this.defaultstep: this.stepSelected,
                "show_future_steps": this.showFutureSteps,
                "mentor_assigned": this.mentor_assigned,
              }
            },
          )
          .then(response => {
              // this.flash({ message: 'New Mentor Added Successfully!', variant: 'success' });
              // this.navigate('/company-admin-dashboard');

              this.disable_add_btn = false;
              this.successMessage = 'New Mentor Added Successfully!';
              this.doFormReset();

              if (this.buttonAction == 'save') {
                this.$refs.first_name.focus();
                setTimeout(() => {
                  this.successMessage = '';
                  this.$emit('closeMentorModal');
                  window.location.reload(); 
                }, 2000);              
              } else {
                this.$refs.first_name.focus();
                setTimeout(() => {
                  this.successMessage = '';
                }, 2000);              
              }
          })
          .catch(error => {
            this.disable_add_btn = false;
              const fieldErrors =  [{}];
              // var errMsgObj = error.response.data.message;
              var errMsgObj = JSON.parse(error.response.data.message);
              Object.keys(errMsgObj).map(key => {
                var newFieldErr = {field:key, msg:errMsgObj[key]};
                fieldErrors.push(newFieldErr);
              });
              this.$validator.errors.add(fieldErrors);
          });
          }, 2000); 
        }
    },
    setupForm(type) {
      this.accountId = this.$store.state.user_accountid;
      var roles = store.state.roles;
      if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
        this.admin = true;
      }
      var role = 'ROLE_MENTOR';
      if(this.form_type == 'add_manager') {
        role = 'ROLE_ADMIN';
      }
      this.getPathwayLists();
      this.taskList = [];
      axios('/accountgroupsactive',
        {
          method: 'GET',
          params: {
            account_id: this.$store.state.user_accountid,
          }
        },
      )
      .then(response => {
          this.groups = response.data;        
        })
      .catch(error => {

      });

      axios.get('/desktop/course-lists', {
        params: {
          user_roles: role,
          accountId: this.$store.state.user_accountid
          }
        })
        .then(response =>  {
          this.courses = response.data;
          for(var i=0; i < this.courses.length; i++) {
            var list = {id: this.courses[i].id + '-' + this.courses[i].type, name: this.courses[i].name};
            this.taskList.push(list);
          }
        })
        .catch(function(error) {
          console.log(error);
        });

      axios.get('/desktop/assessment-builder-lists', {
      params: {
        user_roles: role,
        accountId: this.$store.state.user_accountid
        }
      })
      .then(response =>  {
        this.assessments = response.data;
        for(var i=0; i < response.data.length; i++) {
          var list = {id: response.data[i].id + '-' + response.data[i].type, name: response.data[i].name};
          this.taskList.push(list);
        }
      })
      .catch(function(error) {
        console.log(error);
      });

      axios('/desktop/manager/manage-license', {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
        }
      })
      .then(resp => {
        let accountItems = resp.data;
        this.menteeCount = accountItems.menteesApprentices.length;
        // this.menteesApprentices = accountItems.menteesApprentices;

        let menteesApprentices = accountItems.menteesApprentices.filter(item => item.status == 'Active');
        this.menteesApprentices = menteesApprentices;
        
      })
      .catch(() => {
      });
    },
    navigate(path) {
      router.push(path);
    },
  },
  components: {
    UserMenu,
    GoBack,
    AdminSidebarMenu
  },
  
}
  
</script>
<style scoped>
.signin-form input {
  border: 1px solid #ced4da;
}
.content-main-wrapper {
  width: 75%;
  background-color: #FFF;
  padding: 30px;
}
.start-button-blue {
    color: #fff;
    background-color: #29A3E4;
    border: 1px solid #29A3E4;
    border-radius: 15px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 130px; 
}
.content-main-wrapper {
  width: 90% !important;
  background-color: #FFF !important;
  padding: 25px;
}
input {
  line-height: 17px;
  border-radius: 10px;
  padding-left: 5px !important;
  border: 1px solid #707070;
}
.add-form-heading {
  font-size: 18px;
  font-weight: bold;    
}
.add-form-wrapper {
  margin: 0px 10px 0px 30px; 
}
.add-mentee-form label.bold{
  font-weight: 600;
  padding-left: 0px;
}
.month-picker-input-container {
  width: 100% !important;
}
.month-picker-input {
  width: 100%;
}
.month-picker__container {
  z-index: 1;
  width: 100% !important;
}
.month-picker-elm-container {
  position: relative;
}
.month-picker-elm-container .fa-calendar {
  position: absolute;
  top: 35%;
  right: 5%;
  pointer-events: none;
}    
.save_add_link:focus {
  box-shadow: none;
}
</style>


// WEBPACK FOOTER //
// src/components/manager/add_mentor.vue